import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../apiClient';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';

const OrderHistoryPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get('/orders');
        setOrders(response.data);
      } catch (err) {
        console.error('Error fetching orders:', err);
        setError('Failed to load order history. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const handleViewDetails = (orderId) => {
    navigate(`/orders/${orderId}`);
  };

  return (
    <SessionAuth>
      <div className="container mx-auto p-6 bg-background rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-8 text-center text-gray-800">Your Order History</h1>
        {loading ? (
          <p className="text-center text-gray-600 mb-8">Loading orders...</p>
        ) : error ? (
          <p className="text-center text-red-500 mb-8">{error}</p>
        ) : orders.length === 0 ? (
          <p className="text-center text-gray-600 mb-8">You have no orders yet.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-lg rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-gray-200 text-gray-700 uppercase text-sm leading-normal">
                  <th className="py-3 px-6 text-left">Order ID</th>
                  <th className="py-3 px-6 text-left">Date</th>
                  <th className="py-3 px-6 text-left">Total Amount</th>
                  <th className="py-3 px-6 text-left">Payment Status</th>
                  <th className="py-3 px-6 text-left">Fulfillment Status</th>
                  <th className="py-3 px-6 text-center">Actions</th>
                </tr>
              </thead>
              <tbody className="text-gray-700 text-sm font-light">
                {orders.map((order) => (
                  <tr key={order.id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="py-3 px-6 text-left whitespace-nowrap">{order.id}</td>
                    <td className="py-3 px-6 text-left">{new Date(order.created_at).toLocaleDateString()}</td>
                    <td className="py-3 px-6 text-left">${parseFloat(order.total_amount).toFixed(2)} {order.currency.toUpperCase()}</td>
                    <td className="py-3 px-6 text-left">{order.payment_status}</td>
                    <td className="py-3 px-6 text-left">{order.fulfillment_status}</td>
                    <td className="py-3 px-6 text-center">
                      <button
                        onClick={() => handleViewDetails(order.id)}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded-md text-xs"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </SessionAuth>
  );
};

export default OrderHistoryPage;